import { useEffect } from 'react';
import { useVariablesContext } from '../stores/variables-context';

function useVariablesLoading(): void {
  const { fetchData } = useVariablesContext();

  useEffect(() => {
    fetchData();
  }, [fetchData]);
}

export default useVariablesLoading;
